import { styled } from 'styled-components'

export const RadioLabelUi = styled.label`
  position: relative;
  display: inline-block;
  cursor: pointer;
  width: 18px;
  height: 18px;
`
